import { IContentBlockProps, IContentBlockValuePropProps } from "@proj-common/types"

export const ContentBlock = (props: IContentBlockProps) => {
    const { 
        bgColor = "white"} = props

    return (
        <div className={`bg-transparent ${props.bgColor ? props.bgColor : ""} pl-4 pr-4 pt-8 pb-8`}>
            <div className={`container max-w-4xl mx-auto flex flex-row justify-center md:p-4 text-center`}>
                {props.children}
            </div>
        </div>
    )
}